// libraries
import * as React from "react";
import { INavLink, INavSection } from "~/navigation/navigation-map";
// styles
import * as SC from "./Styled";
// context
import SiteNavContext, { isNavLinkSelected } from "~/navigation/SiteNavContext";
// constants

export type IProps = {
    navSection: INavSection;
};

export const NavPanelSection: React.FC<IProps> = (props) => {

    // BREVITY
    const { navSection } = props;

    const sectionLinks: INavLink[] = navSection.links || [];

    // CONTEXT 
    const navContext: any = React.useContext(SiteNavContext);

    return (
        <SC.StyledNavSection>

                {/* Render each of the section nav links, if any exist */}
                <SC.SectionLinks
                    panelOpen={navContext.panelOpen}
                >
                    {sectionLinks && sectionLinks.map(
                        (link: any) => {
                            let isSelected: boolean = isNavLinkSelected(
                                navContext.selectedSiteLink, navSection.id, link.id
                            );
                            return (
                                <SC.NavLink
                                    key={link.name + link.id} index={link.id}
                                    isSelected={isSelected} panelOpen={navContext.panelOpen}
                                    href={link.link || undefined}
                                    target={link.link ? "_blank" : undefined}
                                    onClick={
                                        () => { 
                                            if (link.route) {
                                                navContext.setSelectedSiteLink([navSection.id, link.id]);
                                                navContext.setSelectedRoute(link.route);
                                            }
                                        }
                                    }
                                >
                                    <SC.LinkIcon isSelected={isSelected}>
                                        {link.iconComp 
                                            ? link.iconComp
                                            : null
                                        }
                                    </SC.LinkIcon>
                                    {   navContext.panelOpen &&
                                        <SC.LinkName>
                                            {link.name}
                                        </SC.LinkName>
                                    }
                                </SC.NavLink>
                            )
                        }
                    )}
                </SC.SectionLinks>
            
        </SC.StyledNavSection>
    )
};

export default NavPanelSection;